import { motion } from "framer-motion";
import { FaDownload, FaArrowRight, FaGraduationCap, FaBriefcase } from "react-icons/fa";
import { commonData, content } from "../data";
import benJpg from "../images/ben_btk.jpg";
import "./home.css";

function Home({ lang }) {
  const t = content[lang];
  const { personal, skills } = commonData;

  return (
    <div className="home-container container">

      <section className="hero-section">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="live-status-container">
            <span className="pulsing-dot"></span>
            <span className="live-text">
              {t.hero.status_prefix} <strong>{t.hero.status_text}</strong> {t.hero.status_suffix}
            </span>
          </div>
          <span className="hero-greeting">{t.hero.greeting}</span>
          <h1 className="hero-title">{personal.name}</h1>
          <h2 className="hero-subtitle">{t.hero.title}</h2>
          <p className="hero-desc">{t.hero.about}</p>

          <div className="hero-buttons">
            <a href="/cv.pdf" download="Burak_Karahan_CV.pdf" className="btn btn-primary">
              <FaDownload /> {t.hero.btn_cv}
            </a>
            <a href="#projects" className="btn btn-outline">
              {t.hero.btn_projects}
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero-image-container"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-img-wrapper">
            <img src={benJpg} alt={personal.name} className="hero-img" />
          </div>
        </motion.div>
      </section>

      {/* Yetenekler Bölümü */}
      <section className="skills-section">
        <h2 className="section-title">{t.sections.skills}</h2>
        <div className="skills-grid">
          {skills.map((skill, index) => (
            <motion.div
              key={index}
              className="skill-card"
              whileHover={{ scale: 1.05, borderColor: "var(--primary)" }}
            >
              <span className="skill-icon">{skill.icon}</span>
              <span>{skill.name}</span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Deneyim Bölümü */}
      <section className="experience-section">
        <h2 className="section-title">
          <FaBriefcase style={{ marginRight: "10px", verticalAlign: "middle", fontSize: "1.6rem" }} />
          {t.sections.experience}
        </h2>
        <div className="glass-grid">
          {t.experience.map((exp, index) => (
            <motion.div 
              key={index} 
              className="glass-card" 
              style={{ borderLeft: "4px solid var(--secondary)" }}
              whileHover={{ y: -4 }}
            >
              <div className="card-top-row">
                <span className="card-date">{exp.date}</span>
                {exp.badge && <span className="card-badge">{exp.badge}</span>}
              </div>
              <h3 className="card-title">{exp.role}</h3>
              <h4 className="card-subtitle">{exp.company}</h4>
              <p className="card-desc">{exp.description}</p>
              {exp.tags && (
                <div className="tags-container" style={{ marginTop: "auto", paddingTop: "12px" }}>
                  {exp.tags.map((tag, i) => (
                    <span key={i} className="tag">#{tag}</span>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </section>

      {/* Eğitim Bölümü */}
      <section className="education-section">
        <h2 className="section-title">
          <FaGraduationCap style={{ marginRight: "10px", verticalAlign: "middle", fontSize: "1.7rem" }} />
          {t.sections.education}
        </h2>
        <div className="glass-grid">
          {t.education.map((edu, index) => (
            <motion.div 
              key={index} 
              className="glass-card" 
              style={{ borderLeft: "4px solid var(--primary)" }}
              whileHover={{ y: -4 }}
            >
              <div className="card-top-row">
                <span className="card-date">{edu.date}</span>
                <div style={{ display: "flex", gap: "8px" }}>
                  {edu.status && <span className="card-badge badge-primary">{edu.status}</span>}
                  {edu.gpa && <span className="card-badge badge-accent">{edu.gpa}</span>}
                </div>
              </div>
              <h3 className="card-title">{edu.field} ({edu.degree})</h3>
              <h4 className="card-subtitle">{edu.school}</h4>
              <p className="card-desc">{edu.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Projeler Bölümü */}
      <section id="projects" className="projects-section">
        <h2 className="section-title">{t.sections.projects}</h2>
        <div className="glass-grid">
          {t.projects.map((project, index) => (
            <motion.div
              key={index}
              className="glass-card"
              whileHover={{ y: -5 }}
            >
              {project.date && <span className="card-date">{project.date}</span>}
              <h3 className="card-title">{project.title}</h3>
              <p className="card-desc">{project.description}</p>

              <div className="tags-container">
                {project.tags.map((tag, i) => (
                  <span key={i} className="tag">#{tag}</span>
                ))}
              </div>

              <a href={project.link} target="_blank" rel="noreferrer" className="project-link">
                {lang === 'tr' ? "GitHub'da İncele" : "View on GitHub"} <FaArrowRight size={12} />
              </a>
            </motion.div>
          ))}
        </div>
      </section>

      <footer className="footer">
        <p>{t.sections.footer}</p>
      </footer>

    </div>
  );
}

export default Home;